import { Dispatch, SetStateAction } from "react"
import { MdFullscreen } from "react-icons/md"
import { typeDailyMenu } from "../types/types"

interface DailyMenuListProps {
    setDailyMenuFullScreen?:Dispatch<SetStateAction<typeDailyMenu | null>>,
    dailyMenu?:typeDailyMenu,
    isForDesk?:boolean,
    id:number,
    activeIndex:number,
    scrollToIndex:(id:number) => void,
    itemRef?: (el: HTMLDivElement | null) => void;
}
export const DailyMenuList:React.FC<DailyMenuListProps> = ({setDailyMenuFullScreen,dailyMenu,id,activeIndex,isForDesk=false,scrollToIndex,itemRef}) => {
    const handleClick = async () => {
        if (id !== activeIndex) {
            scrollToIndex(id);
        }
    }
    const handleClickShow = async () => {
        if (id !== activeIndex) {
            scrollToIndex(id);
            await new Promise(resolve => setTimeout(resolve, 500));
        }
        if(setDailyMenuFullScreen)setDailyMenuFullScreen(dailyMenu ?? null)
    }
    return <div ref={itemRef} className={` ${isForDesk ? 'containerMenu' : 'containerCoverMenu'} ${isForDesk ? (id === activeIndex ? 'isCenter' : 'isNotCenter') : ''} isForDailyMenu`} onClick={(e) => {e.stopPropagation();handleClick()}}>
        <div className="coverMenu">   
            <div className="contentCover"> 
                <div className="dailyMenu frontImg flexAllCenter">
                    <img
                        src={dailyMenu?.image || ''}
                        className={`dailyMenu`}
                        loading="lazy"
                        alt="menu du jour"
                        style={{display: 'flex'}}
                    />
                </div>
                <div className="dailyMenuBackLayer" aria-hidden="true">
                    <img
                        src={dailyMenu?.image || ''}
                        className="dailyMenu backImg"
                        loading="lazy"
                        alt="menu du jour"
                    />
                </div>
                {isForDesk && <>
                <div className="maskContent pointer" style={{zIndex:3,backgroundColor:'transparent'}}>
                    <span className="smallWhiteButton smallText" onClick={(e) => {e.stopPropagation();handleClickShow()}}>
                        <MdFullscreen className="icon" size={18}/>
                        Afficher
                    </span>
                </div>
                <div className="maskContent" style={{backgroundColor:'rgba(255,255,255,0.3)'}}></div>
                </>}
            </div>
            <div className="maskCover"></div>
            {!isForDesk &&
                <div className="fullScreenButton smallTextBold primaryBack" onClick={() => {if(setDailyMenuFullScreen){setDailyMenuFullScreen(dailyMenu ?? null)}}}>
                    <MdFullscreen className="icon" size={18}/>
                    <span>Afficher</span>
                </div>
            }
        </div>
        <div className="footerPartCover">
            <span className="largeTitle">{dailyMenu?.name ?? 'Menu du jour'}</span>
            <i className="dateUpdate XsmallText" style={{gap:0}}>Menu du&nbsp;{dailyMenu ? <>{dailyMenu.dates.length === 1 ? (<i>
                {new Intl.DateTimeFormat("fr-FR", {
                    weekday: "long",
                    day: "numeric",
                    month: "long"
                })
                .format(new Date(dailyMenu.dates[0]))
                .replace(/^./, (str) => str.toUpperCase())}
            </i>   
            ) : (
                <> {new Date(dailyMenu.dates[0]).toLocaleDateString("fr-FR", { day: "numeric", month: "2-digit" })}
                    <i style={{ marginRight: '5px', marginLeft: '5px' }}>au</i>
                    {new Date(dailyMenu.dates[1]).toLocaleDateString("fr-FR", { day: "numeric", month: "2-digit" })}
                </>
            )}</> : '/' }</i>
            {
                <span className="textInteract smallText" style={{opacity:0}}>Carte interactive</span>
            }
        </div>
    </div>
}
